module.exports = __webpack_public_path__ + "img/comments-question.1a70defa.svg";